var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 98,
    viewBox: "0 0 99 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 20.7051,
    width: 80,
    height: 80,
    rx: 10,
    transform: "rotate(-15 0.5 20.7051)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_153_4464)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.536 41.7425C80.5384 56.6795 71.6741 72.033 56.7371 76.0353C41.8 80.0377 26.4466 71.1734 22.4442 56.2364C18.4418 41.2993 27.3061 25.9459 42.2432 21.9435C57.1802 17.9411 72.5337 26.8054 76.536 41.7425ZM48.5624 41.6503C46.225 43.4493 41.5742 47.1227 34.6102 52.6705C33.4664 53.5227 32.9291 54.2004 32.9986 54.7038C33.1159 55.5546 34.2335 55.6025 35.7554 55.6677C35.9624 55.6766 36.1769 55.6858 36.3973 55.6974C37.8985 55.7763 39.8968 55.8037 40.8681 55.5658C41.7491 55.35 42.63 54.7269 43.5108 53.6965C49.5451 46.7499 52.6743 43.2175 52.8985 43.0994C53.0567 43.016 53.2772 42.9054 53.473 43.0036C53.6688 43.1018 53.7246 43.3721 53.727 43.448C53.7415 43.9107 50.7034 48.7563 49.1312 51.264C48.6411 52.0457 48.2934 52.6002 48.2251 52.7239C48.0721 53.0009 47.9118 53.2671 47.7578 53.523C46.8062 55.1035 46.0927 56.2887 48.7967 57.1874C50.0962 57.6193 51.1412 57.9843 52.1838 58.3485C53.3224 58.7462 54.458 59.1429 55.9188 59.6245C56.291 59.7472 56.6511 59.8817 57.0019 60.0127C58.3365 60.5113 59.5355 60.9593 60.7486 60.5116C61.4535 60.2514 62.0179 59.3719 61.854 57.2435C61.4665 52.2136 60.4469 41.3635 59.708 36.9778C59.6432 36.5936 59.4699 36.1261 59.3775 35.9252C59.285 35.7244 59.1294 35.4447 58.7963 35.2959C58.4018 35.1198 57.8867 35.1984 57.664 35.2623C56.6515 35.5528 55.2362 36.5137 48.5624 41.6503Z",
    fill: "#EE5A02"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_153_4464"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(15.1973 29.1904) rotate(-15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.819948ce98161eb613f054d61d7f4b65.svg";
export { ForwardRef as ReactComponent };